import isInstance from './isInstance.js';

const isDate = (x) => isInstance(Date, x);
export default isDate;
